export const SHOW_UPDATE_PAYMENT_SLIDER = 'SHOW_UPDATE_PAYMENT_SLIDER';
export const HIDE_UPDATE_PAYMENT_SLIDER = 'HIDE_UPDATE_PAYMENT_SLIDER';

export const HIDE_UPDATE_PAYMENT_NOTIFICATION = 'HIDE_UPDATE_PAYMENT_NOTIFICATION';

export const UPDATE_PAYMENT_REQUEST = 'UPDATE_PAYMENT_REQUEST';
export const UPDATE_PAYMENT_REQUEST_ERROR = 'UPDATE_PAYMENT_REQUEST_ERROR';
export const UPDATE_PAYMENT_REQUEST_SUCCESS = 'UPDATE_PAYMENT_REQUEST_SUCCESS';

export const TRACK_UPDATE_PAYMENT_SLIDER_ON_LOAD = 'TRACK_UPDATE_PAYMENT_SLIDER_ON_LOAD';
export const TRACK_UPDATE_PAYMENT_SUBMIT_SUCCESS = 'TRACK_UPDATE_PAYMENT_SUBMIT_SUCCESS';
export const TRACK_UPDATE_PAYMENT_SUBMIT_ERROR = 'TRACK_UPDATE_PAYMENT_SUBMIT_ERROR';

export const GET_SAVED_PAYMENT_CARDS = 'GET_SAVED_PAYMENT_CARDS';
export const GET_SAVED_PAYMENT_CARDS_SUCCESS = 'GET_SAVED_PAYMENT_CARDS_SUCCESS';
export const GET_SAVED_PAYMENT_CARDS_ERROR = 'GET_SAVED_PAYMENT_CARDS_ERROR';

export const GET_ADDRESSING_ZIP_CODE = 'GET_ADDRESSING_ZIP_CODE';
export const GET_ADDRESSING_ZIP_CODE_SUCCESS = 'GET_ADDRESSING_ZIP_CODE_SUCCESS';
export const GET_ADDRESSING_ZIP_CODE_ERROR = 'GET_ADDRESSING_ZIP_CODE_ERROR';
